import KeyMetric from '@/pages/CompanyReport/components/Overview/components/Header/components/KeyMetric';
import PencilOutline from '@simplywallst/ui-core/icons/PencilOutline';
import { CompanyIntrinsicDiscount } from '@/components/CompanyIntrinsicDiscount';

import { toCurrencyTruncated } from '@/utilities/formatting';
import type { CurrencyISO } from '@/constants/currencies';

type Props = {
  currencyISO: CurrencyISO | null;
  fairValue: number | null;
  npvPerShare: number | null;
  onClick: () => void;
  lastSharePrice: number | null;
};

export const PopulatedState = ({
  currencyISO,
  fairValue,
  npvPerShare,
  onClick,
  lastSharePrice,
}: Props) => {
  const formattedFairValue = toCurrencyTruncated(
    fairValue || 0,
    2,
    currencyISO ?? 'XXX'
  );

  return (
    <div
      className="cursor-pointer group/narrative-key-metric"
      onClick={onClick}
    >
      <KeyMetric
        type="Metric"
        testId="my-fair-value"
        title={
          <span className="grid gap-1 grid-cols-[max-content_max-content] items-start">
            <span>My Fair Value</span>
            <PencilOutline className="w-x2 h-x2 fill-soft group-hover/narrative-key-metric:fill-solid" />
          </span>
        }
        metric={
          <div className="grid gap-2 grid-cols-[max-content_auto] items-center">
            <span className="m-0 text-xs text-solid">{formattedFairValue}</span>
            <div className="text-tiny">
              <CompanyIntrinsicDiscount
                fairValue={fairValue}
                lastSharePrice={lastSharePrice}
                npvPerShare={npvPerShare}
              />
            </div>
          </div>
        }
      />
    </div>
  );
};
